import uiRouter from 'angular-ui-router';

import Shared from './shared/';

import appConfig from './app.config';
import appComponent from './app.component';

export default angular.module('webPublicClient.app', [
  'rc',
  uiRouter,
  Shared.name
])
.config(appConfig)
.component('app', appComponent);



// WEBPACK FOOTER //
// ./src/app/index.js